// Jobs (GID-Session-010/011) — the parent record of visits, quotes, costs and photos.

/** The workflow, in order (the original app's). Automatic moves only go forward; people can pick any. */
export const JOB_STATUSES = [
  { value: 'enquiry', label: 'Enquiry' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'booked', label: 'Booked' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'complete', label: 'Complete' },
  { value: 'invoiced', label: 'Invoiced' },
  { value: 'cancelled', label: 'Cancelled' }
];

export const OPEN_STATUSES = ['enquiry', 'quoted', 'booked', 'in_progress'];

export const jobStatusLabel = (s) => JOB_STATUSES.find((x) => x.value === s)?.label || s || '';

/** CSS class suffix for a status badge: in_progress → in-progress. */
export const jobStatusClass = (s) => `status-${String(s || '').replace('_', '-')}`;
